import { toast } from 'react-toastify';
import { usersApi } from 'entities/users';

type ChangeUserDataApiReqType = {
  id: number;
  body: {
    reason: string;
  };
};
type ChangeUserDataPasswordApiReqType = {
  id: number;
  body: {
    new_password: string;
  };
};

const resetPasswordDataApi = usersApi.injectEndpoints({
  endpoints: (builder) => ({
    resetPasswordData: builder.mutation<any, ChangeUserDataApiReqType>({
      query: ({ id, body }) => ({
        url: `/account/admin/users/${id}/reset-password`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: (result, error: any, arg) => {
        const error_message = error?.data?.detail;
        if (error) {
          toast.error(error_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          toast.success('Причина принята!', {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        return [
          { type: 'User', id: arg.id },
          { type: 'Users', id: 'ALL' },
        ];
      },
    }),
    setPasswordData: builder.mutation<any, ChangeUserDataPasswordApiReqType>({
      query: ({ id, body }) => ({
        url: `/account/admin/users/${id}/set-password`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: (result, error: any) => {
        const error_message = error?.data?.detail;
        if (error) {
          toast.error(error_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          toast.success('Пароль успешно сменен!', {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        return [{ type: 'User' }, { type: 'Users', id: 'ALL' }];
      },
    }),
  }),
});

export const { useResetPasswordDataMutation, useSetPasswordDataMutation } = resetPasswordDataApi;
